import { applyPatch, compare, deepClone } from 'fast-json-patch'

/**
 * base → local の編集を server に当て直す。
 * 置換・削除する箇所が server 側で変わっていれば当てられないので null を返す。
 */
export const rebaseDocument = <T extends object>(base: T, local: T, server: T): T | null => {
  // invertible: replace/remove の前に base の値の test を入れ、server 側の変更を上書きしないようにする
  const ops = compare(base, local, true)
  if (ops.length === 0) return server
  try {
    return applyPatch(deepClone(server) as T, ops, true, true).newDocument
  } catch {
    return null
  }
}
